import ComponentEx from 'components/ComponentEx';
import { getTxt } from 'global/appGlobal';
import { Dialog, DialogContent } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { EntityTypes, getEntityDescriptor } from 'global/entityDescriptors';
import { compose, graphql } from 'react-apollo';
import LinearProgressEx from '../../components/LinearProgressEx';
import c from '../../components/form/Components';
import MaterialForm from '../../components/form/MaterialForm';
import { DictionaryTypes, getDictionary, getLabel } from '../../global/dictionaryCache';
import { metadataQuery } from '../../home/Home';
import { authInfo, Roles } from '../../global/auth';

import * as queries from '../../modules/company/CompanyQueries';
import { Button } from '@material-ui/core';
import GridEx from 'components/form/GridEx';
import { allTransitAccountQuery, transitAccountByIdQuery, updateTransitAccountMutation } from './TransitAccountQueries';


let history;
let AfterSubmit;
const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing.unit * 2,
        margin: theme.spacing.unit * 2,
    },
    formButtons: {
        float: 'right',
        margin: '15px',
    },
    button: {
        margin: theme.spacing.unit,
    },
});


class Transit_Account_Edit extends ComponentEx {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);

    }

    state = {
        open: false,
    };

    formSetValues = { func: undefined };



    onSubmit(e, { obj, showErrors, hideErrors }) {
        const original = this.props.data.transitAccount;
        obj.transit_account_id = original.transit_account_id;
        
        this.props.update({
            variables: { transitAccount: obj },
            refetchQueries: [
                
                {
                    query: allTransitAccountQuery,
                },
            ],
        }, this).then(
            (resp) => {
                hideErrors();
                if (resp.data.updateTransitAccountMutation &&
                    resp.data.updateTransitAccountMutation.validation &&
                    resp.data.updateTransitAccountMutation.validation.length > 0) {
                    showErrors(resp.data.updateTransitAccountMutation.validation);
                } else {
                    AfterSubmit(resp.data.updateTransitAccountMutation.id);
                }
            });
    }

    render() {

        const { classes } = this.props;

        const loading = this.props.data.loading;
        const item = this.props.data.transitAccount;
        history = this.props.history;
        AfterSubmit = this.props.AfterSubmit;

        const caption = (item && item.transit_account_id !== '-1') ? getTxt('Modifica Operazione') : getTxt('Nuova Operazione');

        return (

            <Dialog onClose={() => { this.props.AfterSubmit(); }} open >
                <DialogContent>
                    <LinearProgressEx loading={loading} />


                    <Typography variant="h4" color="inherit" noWrap={false}>{caption}</Typography>

                    {item &&

                        <MaterialForm
                            dataSource={item}
                            objType={EntityTypes.TransitAccount}
                            onSubmit={this.onSubmit}
                        >
                            <c.field f="payment_account" ui="select" d v={this.props.paymentAccount}>
                                {getDictionary(DictionaryTypes.PaymentAccount)}
                            </c.field>
                            <c.field f="date" />
                            <c.field f="notes" />
                            <c.field f="amount" />
                            <c.field l={getTxt('Payment Type')} f="payment_type_cd" ui="select" >
                                {getDictionary(DictionaryTypes.PaymentType)}
                            </c.field>
                            <c.field l={getTxt('Entrata/Uscita')} f="direction" ui="select" >
                                {getDictionary(DictionaryTypes.TransitAccountDirection)}
                            </c.field>
                            
                            
                            
                            


                            <GridEx item sm={12} xs={12}>
                                <div className={classes.formButtons} >
                                    <Button
                                        className={classes.button}
                                        style={{marginRight: 10}}
                                        variant="contained"
                                        onClick={() => {
                                            this.props.AfterSubmit();
                                        }}
                                    >{getTxt('Annulla')}</Button>
                                    <Button
                                        color="primary"
                                        className={classes.button}
                                        type="submit"
                                        variant="contained"
                                    > {getTxt('Save')}</Button>
                                </div>

                            </GridEx>
                        </MaterialForm>

                    }

                </DialogContent>

            </Dialog>

        );
    }
}

export default compose(

    graphql(transitAccountByIdQuery, {
        options: props => (
            {
                variables: {
                    id: props.id ? props.id : 'new',
                },
                fetchPolicy: 'network-only',
                errorPolicy: 'all',
            }
        ),
    }),

    graphql(updateTransitAccountMutation, {
        name: 'update',
        options: {
            errorPolicy: 'all',
        },
    }),

)(withStyles(styles)(Transit_Account_Edit));
